module.exports = __webpack_public_path__ + "static/media/2_tnc.687de6e8.svg";